// extracted by mini-css-extract-plugin
export default {"button_main_margin":"OrderPlasticCardStatusContent_button_main_margin__1wyWZ"};